import React, { useState, useEffect, useContext } from 'react';
import { Link, Switch, Route, useLocation, useRouteMatch, useHistory, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { css, StyleSheet } from 'aphrodite/no-important';
import { ThemeContext } from 'quantux-ui';
import PracticeProvidersGrid from './practice-providers-grid';
import PracticeFacilitiesGrid from './practice-facilities-grid';
import PracticeUsersGrid from './practice-users-grid';
import AboutPractice from './about-practice';
import { BASE_URL, DRAWER_BREAK_POINT } from '../../utils';
import { togglePracticeDataReloadFlag } from '../../actions';
import { gray, blue, salmon, theme } from '../../theme';
import PracticeAccessManagersGrid from './practice-access-managers-grid';

const drawerWidth = window.innerWidth <= DRAWER_BREAK_POINT ? window.innerWidth : 320;
const NAVBAR_HEIGHT = 70;

const NoView = (
  <div className='mt-2' style={{ textAlign: 'center', animation: 'pulse-white 2s infinite' }}>
    <i
      className='fa fa-times-circle-o'
      style={{
        fontSize: '128px',
        color: salmon[500]
      }}
    />
    <div style={{ fontSize: '32px' }}>
      You do not have permission to view
    </div>
  </div>
);

const noAccessIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="19"
    fill="none"
  >
    <path
      fill="#96C8FF"
      fillRule="evenodd"
      d="m3.281 3.55-2.28-2.28L2.27 0l17.738 17.73L18.74 19l-2.932-2.92-.42-.42c-1.35.54-2.831.84-4.382.84C6.003 16.5 1.731 13.39 0 9c.78-1.98 2.081-3.7 3.742-4.99l-.46-.46ZM16.007 9c0-2.76-2.24-5-5.002-5-.65 0-1.26.13-1.83.36L7.012 2.2c1.24-.45 2.581-.7 3.982-.7C15.997 1.5 20.269 4.61 22 9c-.73 1.86-1.92 3.49-3.432 4.75l-2.92-2.92c.23-.57.36-1.18.36-1.83ZM6.533 6.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.341 3 3.002 3 .22 0 .44-.03.65-.08l1.551 1.55c-.67.33-1.41.53-2.201.53a5.003 5.003 0 0 1-5.002-5c0-.79.2-1.53.53-2.2Zm7.463 2.37-3.151-3.15.17-.01c1.66 0 3.001 1.34 3.001 3l-.02.16Z"
      clipRule="evenodd"
    />
  </svg>
);

const readOnlyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="15"
    fill="none"
  >
    <path
      fill="#96C8FF"
      fillRule="evenodd"
      d="M10 0C5.455 0 1.573 3.11 0 7.5 1.573 11.89 5.455 15 10 15c4.546 0 8.427-3.11 10-7.5C18.427 3.11 14.546 0 10 0Zm0 12.5c-2.51 0-4.545-2.24-4.545-5s2.036-5 4.545-5c2.51 0 4.546 2.24 4.546 5s-2.037 5-4.546 5Zm-2.727-5c0-1.66 1.218-3 2.727-3 1.51 0 2.727 1.34 2.727 3s-1.218 3-2.727 3c-1.51 0-2.727-1.34-2.727-3Z"
      clipRule="evenodd"
    />
  </svg>
);

const readWriteIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
  >
    <path
      fill="#96C8FF"
      fillRule="evenodd"
      d="M17.707 2.632c.39.39.39 1.02 0 1.41l-1.83 1.83-3.749-3.75 1.83-1.83a.996.996 0 0 1 1.41 0l2.34 2.34ZM0 18v-3.75L11.059 3.193l3.749 3.75L3.749 18H0Z"
      clipRule="evenodd"
    />
  </svg>
);

const drawerTabs = {
  about: 'About Profile',
  providers: 'Providers',
  facilities: 'Facilities',
  insurance: 'Insurance',
  revenueCycle: 'Revenue Cycle Management',
  scheduling: 'Scheduling'
};

const PracticeProviders = (props) => {
  return (
    <h1>Practice Providers</h1>
  );
};

const PracticeFacilities = (props) => {
  return (
    <h1>Practice Facilities</h1>
  );
};

const Placeholder = props => <h1>{props.text}</h1>;

const PracticeDashboard = (props) => {
  const [isMobileLayout, setMobileLayout] = useState(false);
  const [isDrawerOpen, toggleDrawer] = useState(true);
  const [activeComponent, setActiveComponent] = useState(drawerTabs.about);
  const [activePractice, setActivePractice] = useState({});
  const [isAdminOrManager, setIsAdminOrManager] = useState(false);
  const [profileAccess, setProfileAccess] = useState({
    profile: 4,
    caseLedger: 0,
    paymentsLedger: 0,
    credentialing: 0,
    insurance: 0,
    providers: 0,
    collaborators: 0,
    facilityCoverage: 0,
    accessManager: 0
  });

  const location = useLocation();
  const history = useHistory();
  const { pathname } = location;
  const { path, url } = useRouteMatch();
  const { practiceNpi } = useParams();

  // console.log('----------------Practice Dashboard ----------------');
  // console.log(`pathname = ${pathname}`);
  // console.log(`path = ${path}`);
  // console.log(`url = ${url}`);

  // Split panel theme
  const {
    drawerBackground,
    drawerBorderColor,
    drawerTextColor,
    drawerFontSize,
    drawerFontWeight,
    // Drawer Tabs
    tabBackground,
    tabActiveBackground,
    tabHoverBackground,
    tabIndicatorBackground,
    tabIndicatorHoverBackground,
    tabIndicatorActiveBackground,
    tabTextColor,
    tabHoverTextColor,
    tabActiveTextColor,
    tabFontSize,
    tabFontWeight,
    groupSeparators,
    headerBackground,
    headerTextColor,
    headerFontSize,
    headerFontWeight,
    groupHeaderTextColor,
    groupHeaderTextOpacity,
    groupHeaderFontSize,
    groupHeaderFontWeight,
    groupTabIndent
  } = theme.splitPanelDrawer;

  const loadPracticeData = () => {
    // const practice = localStorage.getItem('practice');
    // const parts = practice.split('/');
    // const practiceNpi = +(parts[1]);
    const reqHeaders = new Headers();
    const token = localStorage.getItem('token');
    reqHeaders.append('Authorization', `Bearer ${token}`);
    const url = new URL(`${BASE_URL}/practice/getPracticeProfile`);
    const params = { npi: practiceNpi };
    url.search = new URLSearchParams(params).toString();

    fetch(url, { method: 'GET', headers: reqHeaders })
      .then(response => response.text())
      .then(result => {
        props.togglePracticeDataReloadFlag(false);
        const reqData = JSON.parse(result);
        setProfileAccess(reqData.access);
        setActivePractice(reqData.practice);
      })
      .catch(error => console.log('error', error));
  };

  const handleWindowResize = () => {
    const isMobile = window.innerWidth <= 768;
    toggleDrawer(!isMobile);
    setMobileLayout(isMobile);
  };

  // Effects hook
  useEffect(() => {
    loadPracticeData();
  }, []);

  // Window resize event effect
  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);
    handleWindowResize();
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  // Refs
  const userIcon = React.createRef();

  // Theme
  const context = useContext(ThemeContext);

  // ------------------------------ Styles ------------------------------
  const stylesOld = StyleSheet.create({
    dashboardHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '24px',
      padding: '0 8px',
      background: gray[500],
      color: gray[300]
    },
    dashboardHeaderIcon: {
      fontSize: '18px',
      color: salmon[500],
      cursor: 'pointer'
    },
    splitPanel: {
      display: 'flex',
      flexFlow: 'row nowrap',
      // position: 'relative',
      background: gray[800],
      height: 'calc(100vh - 42px)',
      width: '100%',
      overflow: 'hidden',
      fontFamily: 'Lato'
    },
    drawer: {
      position: 'relative',
      height: 'calc(100vh - 40px)',
      minWidth: '320px',
      width: '320px',
      transition: '0.3s',
      left: '0',
      padding: '0',
      overflowY: 'auto',
      zIndex: '1900',
      borderRight: `1px solid ${gray[700]}`,
      background: gray[800]
    },
    hideDrawer: {
      transition: '0.3s',
      left: 'calc(-1 * 320px)'
    },
    drawerHeader: {
      height: '40px',
      fontSize: '16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'left',
      marginLeft: '8px',
      cursor: 'pointer',
      background: gray[900],
      borderBottom: `0.5px solid ${gray[700]}`
    },
    drawerHeaderIconContainer: {
      color: '#0080FF',
      height: '32px',
      width: '32px',
      background: '#0080FF',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: '4px',
      cursor: 'pointer'
    },
    drawerHeaderIcon: {
      fontSize: '24px',
      color: 'white',
      cursor: 'pointer'
    },
    drawerHeaderTextContainer: {
      textAlign: 'left',
      lineHeight: '14px',
      cursor: 'pointer'
    },
    drawerHeaderText: {
      textAlign: 'center',
      fontSize: '14px',
      color: gray[300],
      cursor: 'pointer'
    },
    drawerHeaderTextSub: {
      color: '#0080FF',
      fontSize: '14px',
      cursor: 'pointer'
    },
    drawerTabsContainer: {
      height: 'calc(100% - 64px)',
      overflowY: 'auto'
    },
    drawerAccordian: {
      position: 'relative',
      display: 'block',
      transition: '0.5s ease',
      maxHeight: '2000px'
    },
    menuItem: {
      position: 'relative',
      left: '-3px',
      color: gray[300]
    },
    detail: {
      // position: 'relative',
      transition: '0s',
      height: 'calc(100vh - 40px)',
      width: 'calc(100vw - 320px)',
      left: '0'
    },
    detailExapnd: {
      transition: '0.2s',
      left: 'calc(-1 * 320px)',
      width: '100vw'
    },
    detailHeader: {
      height: '40px',
      background: '#001824',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderBottom: '0.5px solid #082840',
      padding: '0 8px'
    },
    profileBanner: {
      borderBottom: '1px solid transparent'
    },
    profileBannerImg: {
      width: '100%',
      height: 'auto',
      maxHeight: '220px'
    },
    bigUserCardContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      borderBottom: '1px solid transparent'
    },
    tabs: {
      // borderBottom: '1px solid red'
    },
    popupMenuContainer: {
      background: '#083050',
      width: '150px',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.5)'
    },
    popupMenuItem: {
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      color: '#5080B0'
    },
    menuItemIconContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '40px',
      width: '40px'
    },
    menuItemIcon: {
      fontSize: '20px'
    },
    accordianRightBorder: {
      position: 'absolute',
      width: '1px',
      height: 'calc(100% - 40px)',
      background: '#305C82',
      left: '13px',
      top: '40px'
    },
    linkStyles: {
      display: 'flex',
      alignItems: 'center',
      color: gray[300]
    },
    selectedLink: {
      color: blue[500]
    },
    drawerFile: {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: '4px',
      color: blue[500],
      height: '40px'
    },
    drawerFileIcon: {
      fontSize: '32px',
      marginRight: '8px'
    },
    activeDrawerMenuItem: {
      borderLeft: `1px solid ${blue[500]}`,
      color: blue[500],
      background: gray[700]
    }
  });

  const styles = StyleSheet.create({
    dashboardHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '32px',
      padding: '0 8px',
      background: gray[500],
      color: gray[300]
    },
    dashboardHeaderIcon: {
      fontSize: '18px',
      color: salmon[500],
      cursor: 'pointer'
    },
    splitPanel: {
      display: 'flex',
      flexFlow: 'row nowrap',
      background: gray[800],
      // height: `calc(100vh - ${NAVBAR_HEIGHT}px)`,
      height: 'calc(100% - 32px)',
      width: '100%',
      overflow: 'hidden',
      fontFamily: 'Lato'
    },
    drawer: {
      // display: isAdminOrManager ? '' : 'none',
      position: 'relative',
      height: '100%',
      transition: '0.3s',
      padding: isDrawerOpen ? '8px' : '0',
      // overflowY: 'auto',
      zIndex: '1900',
      borderRight: `1px solid ${gray[700]}`,
      background: gray[800]
    },
    openDrawer: {
      left: '0',
      minWidth: `${drawerWidth}px`,
      width: `${drawerWidth}px`
    },
    hideDrawer: {
      transition: '0.3s',
      width: '0px',
      minWidth: '0px',
      left: `calc(-1 * ${drawerWidth}px)`
    },
    drawerHeader: {
      height: '40px',
      fontSize: '16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'left',
      cursor: 'pointer',
      // background: headerBackground,
      background: blue[800],
      color: headerTextColor,
      borderBottom: `0.5px solid ${drawerBorderColor}`,
      ':hover:not(.activeitem)': {
        background: tabHoverBackground,
        color: tabHoverTextColor
      }
    },
    drawerHeaderActive: {
      color: tabActiveTextColor,
      background: tabActiveBackground
    },
    drawerHeaderIconContainer: {
      height: '32px',
      // width: '32px',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 4px',
      cursor: 'pointer'
    },
    drawerHeaderIcon: {
      fontSize: '24px',
      cursor: 'pointer'
    },
    drawerHeaderTextContainer: {
      textAlign: 'left',
      lineHeight: '16px',
      cursor: 'pointer'
    },
    drawerHeaderText: {
      // textAlign: 'center',
      fontSize: '14px',
      cursor: 'pointer',
      paddingLeft: '4px',
      fontWeight: 'bold'
    },
    drawerHeaderTextSub: {
      fontSize: '12px',
      cursor: 'pointer',
      paddingLeft: '4px'
    },
    drawerTabsContainer: {
      // height: `calc(100% - ${NAVBAR_HEIGHT + 64}px)`,
      height: 'calc(100% - 40px)',
      overflowY: 'auto'
    },
    drawerAccordian: {
      position: 'relative',
      display: 'block',
      transition: '0.5s ease',
      maxHeight: '2000px'
    },
    drawerFile: {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: '8px',
      color: blue[200],
      height: '40px'
    },
    drawerMenuItem: {
      position: 'relative',
      // background: tabBackground,
      marginTop: '1px',
      background: blue[800],
      color: tabTextColor,
      fill: tabTextColor,
      borderLeft: `1px solid ${tabIndicatorBackground}`,
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      // justifyContent: 'left',
      justifyContent: 'space-between',
      paddingRight: '8px',
      paddingLeft: groupTabIndent,
      ':hover:not(.activeitem):not(.disabled)': {
        background: tabHoverBackground,
        color: tabHoverTextColor,
        fill: tabHoverTextColor,
        borderLeft: `1px solid ${tabIndicatorHoverBackground}`
      }
    },
    drawerMenuItemIcon: {
      height: '24px',
      // width: '30px',
      width: '42px',
      minWidth: '24px',
      marginRight: '8px',
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '24px'
    },
    drawerMenuItemActive: {
      color: blue[500],
      background: blue[900]
    },
    drawerMenuItemText: {
      width: '100%',
      fontSize: '1rem',
      lineHeight: '14px'
    },
    linkStyles: {
      display: 'flex',
      alignItems: 'center',
      color: gray[300]
    },
    selectedLink: {
      color: blue[500]
    },
    menuItem: {
      position: 'relative',
      left: '-3px',
      color: gray[300]
    },
    detail: {
      // position: 'relative',
      transition: '0s',
      height: `calc(100vh - ${NAVBAR_HEIGHT}px)`,
      width: 'calc(100vw - 320px)',
      // width: isAdminOrManager ? 'calc(100vw - 320px)' : '100vw',
      left: '0'
    },
    detailExapnd: {
      transition: '0.2s',
      left: 'calc(-1 * 320px)',
      width: '100vw'
    },
    detailHeader: {
      height: '40px',
      background: '#001824',
      display: 'flex',
      alignItems: 'center',
      borderBottom: '0.5px solid #082840',
      padding: '0 8px'
    }
  });

  const handleOnClickMiniUserCard = () => {
    history.push(`${url}/profile`);
    if (isMobileLayout) {
      toggleDrawer(false);
    }
  };

  const handleReloadPracticeData = () => {
    loadPracticeData();
  };

  let activeText = '';
  switch (activeComponent) {
    case drawerTabs.providers:
      activeText = drawerTabs.providers;
      break;
    case drawerTabs.facilities:
      activeText = drawerTabs.facilities;
      break;
    case drawerTabs.insurance:
      activeText = drawerTabs.insurance;
      break;
    case drawerTabs.scheduling:
      activeText = drawerTabs.scheduling;
      break;
    case drawerTabs.revenueCycle:
      activeText = drawerTabs.revenueCycle;
      break;
    case drawerTabs.about:
    default:
      activeText = drawerTabs.about;
  }

  if (props.shouldReloadPracticeData) {
    loadPracticeData();
  }

  return (
    <div style={{ height: 'calc(100% - 40px)' }}>
      {/* Dashboard Header */}
      <div className={css(styles.dashboardHeader)}>
        <div>Practice Profile</div>
        <div
          className={css(styles.dashboardHeaderIcon)}
          onClick={() => {
            if (props.usr.isMasterAdmin) {
              const lastBookmark = localStorage.getItem('lastBookmark') || '/admin/users';
              localStorage.setItem('lastBookmark', '');
              history.push(lastBookmark);
            } else {
              const lastBookmark = localStorage.getItem('lastBookmark') || '/user/practices';
              localStorage.setItem('lastBookmark', '');
              history.push(lastBookmark);
            }
          }}
        >
          <i className='fa fa-times-circle' />
        </div>
      </div>
      <div className={css(styles.splitPanel)}>
        {/* Panel Drawer */}
        <div
          className={css(styles.drawer, isDrawerOpen ? styles.openDrawer : styles.hideDrawer)}
        >
          {/* Drawer header (Mini user card) */}
          <div
            className={`noselect
              ${(pathname.indexOf('/profile') > -1) ? 'activeitem' : ''}
              ${css(styles.drawerMenuItem, (pathname.indexOf('/profile') > -1) && styles.drawerMenuItemActive)}`
            }
            onClick={handleOnClickMiniUserCard}
          >
            {/* Header icon */}
            <div className={css(styles.drawerHeaderIconContainer)}>
              {activePractice.avatarImageUrl
                ? <img
                  src={activePractice.avatarImageUrl}
                  alt="avatar"
                  style={{
                    width: 'auto',
                    height: '28px',
                    maxHeight: '28px',
                    borderRadius: '4px'
                  }}
                />
                : <i className={`fa fa-hospital-o ${css(styles.drawerHeaderIcon)}`} />
              }
              <div style={{ lineHeight: '14px', width: '210px' }}>
                <div className={`text-truncate ${css(styles.drawerHeaderText)}`}>
                  {`${activePractice.displayName ? activePractice.displayName : 'N/A'}`}
                </div>
                <div className={css(styles.drawerHeaderTextSub)}>
                  {`@${activePractice.userName ? activePractice.userName : 'n/a'}`}
                </div>
              </div>
            </div>
            {/* Access */}
            <div className='fx fx__v-center'>
              {profileAccess.profile === 6 && readWriteIcon}
              {profileAccess.profile === 4 && readOnlyIcon}
              {profileAccess.profile === 0 && noAccessIcon}
            </div>
          </div>
          {/* Drawer tabs */}
          <div
            className={css(styles.drawerTabsContainer)}
          >
            <div className={css(styles.drawerAccordian)}>
              {/* Case Ledger */}
              <div
                className={`noselect
                  ${profileAccess.caseLedger === 0 ? 'disabled' : ''}
                  ${(pathname.endsWith('/revenue') || pathname.endsWith('/cases')) ? 'activeitem' : ''}
                  ${css(styles.drawerMenuItem, (pathname.endsWith('/revenue') || pathname.endsWith('/cases')) &&
                  styles.drawerMenuItemActive)}`}
                onClick={() => {
                  if (profileAccess.caseLedger !== 0) {
                    history.push(`${url}/revenue`);
                    if (isMobileLayout) {
                      toggleDrawer(false);
                    }
                  }
                }}
              >
                <Link
                  to={`${url}/revenue`}
                  // className={css(styles.linkStyles, pathname.endsWith('/revenue') && styles.selectedLink)}
                  className={`${profileAccess.caseLedger === 0 ? 'disabled-link' : ''} ${css(styles.linkStyles, pathname.endsWith('/revenue') && styles.selectedLink)}`}
                  onClick={() => {
                    if (isMobileLayout) {
                      toggleDrawer(false);
                    }
                  }}
                >
                  <div className={css(styles.drawerMenuItemIcon)}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="none"
                    >
                      <path
                        fill="#96C8FF"
                        fillRule="evenodd"
                        d="M16.8 5.053h4.8c1.332 0 2.4 1.124 2.4 2.526v13.895C24 22.876 22.932 24 21.6 24H2.4C1.068 24 0 22.876 0 21.474L.012 7.579c0-1.402 1.056-2.526 2.388-2.526h4.8V2.526C7.2 1.124 8.268 0 9.6 0h4.8c1.332 0 2.4 1.124 2.4 2.526v2.527Zm-7.2-.001h4.8V2.525H9.6v2.527Z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <div className={css(styles.drawerMenuItemText)} >
                    Case Ledger
                  </div>
                </Link>
                {/* Access */}
                <div className='fx fx__v-center'>
                  {profileAccess.caseLedger === 6 && readWriteIcon}
                  {profileAccess.caseLedger === 4 && readOnlyIcon}
                  {profileAccess.caseLedger === 0 && noAccessIcon}
                </div>
              </div>
              {/* Payments Ledger */}
              <div
                className={`noselect
                  ${profileAccess.paymentsLedger === 0 ? 'disabled' : ''}
                  ${pathname.endsWith('/payments') ? 'activeitem' : ''}
                  ${css(styles.drawerMenuItem, pathname.endsWith('/payments') &&
                  styles.drawerMenuItemActive)}`}

                onClick={() => {
                  if (profileAccess.paymentsLedger !== 0) {
                    history.push(`${url}/payments`);
                    if (isMobileLayout) {
                      toggleDrawer(false);
                    }
                  }
                }}
              >
                <Link
                  to={`${url}/payments`}
                  className={`${profileAccess.paymentsLedger === 0 ? 'disabled-link' : ''} ${css(styles.linkStyles, pathname.endsWith('/payments') && styles.selectedLink)}`}
                  onClick={() => {
                    if (isMobileLayout) {
                      toggleDrawer(false);
                    }
                  }}
                >
                  <div className={css(styles.drawerMenuItemIcon)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
                      <path fill="#96C8FF" fillRule="evenodd" d="M23.157 3a.843.843 0 0 0-.844.844v2.015A12.007 12.007 0 0 0 18.633 2 11.94 11.94 0 0 0 12.001 0a11.955 11.955 0 0 0-8.18 3.22 11.958 11.958 0 0 0-3.787 7.873.844.844 0 0 0 .778.904C.833 12 .854 12 .875 12a.845.845 0 0 0 .842-.78A10.278 10.278 0 0 1 4.97 4.454 10.28 10.28 0 0 1 12 1.687c2.04 0 4.01.593 5.7 1.718a10.303 10.303 0 0 1 3.488 3.907h-2.344a.843.843 0 1 0 0 1.688h4.313A.843.843 0 0 0 24 8.156V3.844A.843.843 0 0 0 23.157 3Zm.029 9.002a.845.845 0 0 0-.905.778 10.278 10.278 0 0 1-3.253 6.764A10.27 10.27 0 0 1 12 22.312a10.25 10.25 0 0 1-5.7-1.718 10.303 10.303 0 0 1-3.488-3.907h2.344a.843.843 0 1 0 0-1.688H.844a.843.843 0 0 0-.844.844v4.313a.843.843 0 1 0 1.687 0V18.14A12.025 12.025 0 0 0 5.365 22c1.968 1.308 4.26 2 6.635 2 3.046 0 5.953-1.145 8.179-3.221a11.944 11.944 0 0 0 3.785-7.872.843.843 0 0 0-.778-.905ZM10.653 9.833c0 .633.487 1.04 2 1.433 1.513.394 3.133 1.04 3.133 2.934 0 1.366-1.033 2.12-2.333 2.366V18h-2v-1.446c-1.28-.274-2.373-1.094-2.453-2.554h1.466c.074.787.614 1.4 1.987 1.4 1.473 0 1.8-.733 1.8-1.193 0-.62-.334-1.207-2-1.606-1.86-.447-3.133-1.214-3.133-2.754 0-1.286 1.04-2.126 2.333-2.406V6h2v1.46c1.393.34 2.093 1.393 2.14 2.54H14.12c-.04-.834-.48-1.4-1.667-1.4-1.127 0-1.8.506-1.8 1.233Z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className={css(styles.drawerMenuItemText)} >
                    Payments Ledger
                  </div>
                </Link>
                {/* Access */}
                <div className='fx fx__v-center'>
                  {profileAccess.paymentsLedger === 6 && readWriteIcon}
                  {profileAccess.paymentsLedger === 4 && readOnlyIcon}
                  {profileAccess.paymentsLedger === 0 && noAccessIcon}
                </div>
              </div>
              {/* Credentailing */}
              <div
                // className={`noselect ${pathname.endsWith('/credentialing') ? 'activeitem' : ''} ${css(styles.drawerMenuItem, pathname.endsWith('/credentialing') && styles.drawerMenuItemActive)}`}
                className={`noselect
                  ${profileAccess.credentialing === 0 ? 'disabled' : ''}
                  ${pathname.endsWith('/credentialing') ? 'activeitem' : ''}
                  ${css(styles.drawerMenuItem, pathname.endsWith('/credentialing') &&
                  styles.drawerMenuItemActive)}`}

                onClick={() => {
                  if (profileAccess.credentialing !== 0) {
                    history.push(`${url}/credentialing`);
                    if (isMobileLayout) {
                      toggleDrawer(false);
                    }
                  }
                }}
              >
                <Link
                  to={`${url}/credentialing`}
                  className={`${profileAccess.credentialing === 0 ? 'disabled-link' : ''} ${css(styles.linkStyles, pathname.endsWith('/credentialing') && styles.selectedLink)}`}
                  onClick={() => {
                    if (isMobileLayout) {
                      toggleDrawer(false);
                    }
                  }}
                >
                  <div className={css(styles.drawerMenuItemIcon)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" fill="none">
                      <path fill="#96C8FF" d="M24 11.444 21.338 8.4l.371-4.025-3.938-.895L15.709 0 12 1.593 8.29 0 6.23 3.48l-3.94.884.372 4.036L0 11.444l2.662 3.043-.371 4.037 3.938.894 2.062 3.491L12 21.305l3.71 1.593 2.06-3.48 3.94-.894-.372-4.026L24 11.444Zm-4.31 1.614-.61.71.087.926.197 2.128-2.99.676-.48.807-1.08 1.833-1.941-.84-.873-.37-.862.37-1.942.84-1.08-1.822-.48-.807-2.989-.676.197-2.138.087-.928-.611-.709-1.407-1.604L4.32 9.84l.61-.71-.097-.937-.197-2.117 2.99-.676.48-.807 1.08-1.833 1.941.84.873.37.862-.37 1.942-.84 1.08 1.833.48.807 2.989.676-.197 2.128-.087.927.611.709 1.407 1.604-1.396 1.614Z" /><path fill="#96C8FF" d="m9.916 13.364-2.53-2.542-1.615 1.625 4.145 4.157 8.008-8.03-1.615-1.625-6.393 6.415Z" />
                    </svg>
                  </div>
                  <div className={css(styles.drawerMenuItemText)} >
                    Credentialing
                  </div>
                </Link>
                {/* Access */}
                <div className='fx fx__v-center'>
                  {profileAccess.credentialing === 6 && readWriteIcon}
                  {profileAccess.credentialing === 4 && readOnlyIcon}
                  {profileAccess.credentialing === 0 && noAccessIcon}
                </div>
              </div>
              {/* Insurance */}
              <div
                className={`noselect
                  ${profileAccess.insurance === 0 ? 'disabled' : ''}
                  ${pathname.endsWith('/insurance') ? 'activeitem' : ''}
                  ${css(styles.drawerMenuItem, pathname.endsWith('/insurance') &&
                  styles.drawerMenuItemActive)}`}
                onClick={() => {
                  if (profileAccess.insurance !== 0) {
                    history.push(`${url}/insurance`);
                    if (isMobileLayout) {
                      toggleDrawer(false);
                    }
                  }
                }}
              >
                <Link
                  to={`${url}/insurance`}
                  className={`${profileAccess.insurance === 0 ? 'disabled-link' : ''} ${css(styles.linkStyles, pathname.endsWith('/insurance') && styles.selectedLink)}`}
                  onClick={() => {
                    if (isMobileLayout) {
                      toggleDrawer(false);
                    }
                  }}
                >
                  <div className={css(styles.drawerMenuItemIcon)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" fill="none">
                      <path fill="#96C8FF" fillRule="evenodd" d="M4 0a4 4 0 0 0-4 4v20.8a4 4 0 0 0 4 4h20.8a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4H4Zm.202 5.829L14.488 2.4l10.286 3.429v10.285c0 5.681-4.605 10.286-10.286 10.286-5.681 0-10.286-4.604-10.286-10.286V5.83Zm18.644 10.283a8.357 8.357 0 0 1-16.715 0V7.273l8.357-2.946 8.358 2.946v8.84Zm-9.793-3.88c0 .633.487 1.04 2 1.433 1.514.393 3.133 1.04 3.133 2.933 0 1.367-1.033 2.12-2.333 2.367v1.433h-2v-1.446c-1.28-.274-2.373-1.094-2.453-2.554h1.466c.074.787.614 1.4 1.987 1.4 1.473 0 1.8-.733 1.8-1.193 0-.62-.333-1.207-2-1.607-1.86-.446-3.133-1.213-3.133-2.753 0-1.287 1.04-2.127 2.333-2.407v-1.44h2v1.46c1.394.34 2.094 1.394 2.14 2.54H16.52c-.04-.833-.48-1.4-1.667-1.4-1.127 0-1.8.507-1.8 1.234Z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className={css(styles.drawerMenuItemText)} >
                    Insurance
                  </div>
                </Link>
                {/* Access */}
                <div className='fx fx__v-center'>
                  {profileAccess.insurance === 6 && readWriteIcon}
                  {profileAccess.insurance === 4 && readOnlyIcon}
                  {profileAccess.insurance === 0 && noAccessIcon}
                </div>
              </div>
              {/* Separator */}
              <div className={css(styles.drawerFile)}>
                <div>
                  Providers/Collaborators/Coverage
                </div>
              </div>
              {/* Providers */}
              <div
                className={`noselect
                  ${profileAccess.providers === 0 ? 'disabled' : ''}
                  ${pathname.endsWith('/providers') ? 'activeitem' : ''}
                  ${css(styles.drawerMenuItem, pathname.endsWith('/providers') &&
                  styles.drawerMenuItemActive)}`}
                onClick={() => {
                  if (profileAccess.providers !== 0) {
                    history.push(`${url}/providers`);
                    if (isMobileLayout) {
                      toggleDrawer(false);
                    }
                  }
                }}
              >
                <Link
                  to={`${url}/providers`}
                  className={`${profileAccess.providers === 0 ? 'disabled-link' : ''} ${css(styles.linkStyles, pathname.endsWith('/providers') && styles.selectedLink)}`}
                  onClick={() => {
                    if (isMobileLayout) {
                      toggleDrawer(false);
                    }
                  }}
                >
                  <div className={css(styles.drawerMenuItemIcon)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
                      <rect width="23" height="23" x=".5" y=".5" fill="#96C8FF" stroke="#001824" rx="3.5" /><path fill="#001824" d="M5.624 21.001a.332.332 0 0 1-.328-.282 5.707 5.707 0 0 1 .214-2.427c.024-.068.575-1.623 1.884-2.022a5.145 5.145 0 0 1 1.56-.262c.065 0 .129.019.183.054 1.012.665 1.875 1.114 2.792 1.145.916 0 1.722-.424 2.732-1.108a.294.294 0 0 1 .04-.023.369.369 0 0 1 .213-.068c1.217 0 2.159.378 2.799 1.124 1.183 1.38.873 3.498.86 3.587a.333.333 0 0 1-.659-.1c.003-.02.275-1.912-.709-3.056-.493-.573-1.235-.872-2.205-.889l-.006.003c-1.096.739-1.992 1.195-3.043 1.195h-.045c-1.044-.035-1.979-.502-3.049-1.197a4.635 4.635 0 0 0-1.269.232c-.988.301-1.443 1.588-1.448 1.601a5.107 5.107 0 0 0-.186 2.11.331.331 0 0 1-.33.383Z" /><path fill="#001824" d="M10.187 19.637a.333.333 0 0 1-.308-.205l-1.231-2.963a.333.333 0 1 1 .615-.256l1.037 2.494 1.345-1.398a.334.334 0 1 1 .48.461l-1.698 1.765a.333.333 0 0 1-.24.102Z" /><path fill="#001824" d="M12.748 18.738a.334.334 0 0 1-.235-.097l-.866-.866a.333.333 0 1 1 .47-.47l.867.865a.333.333 0 0 1-.236.568Z" /><path fill="#001824" d="M13.612 19.637a.332.332 0 0 1-.24-.102l-.866-.899a.334.334 0 0 1 .48-.462l.515.535 1.012-2.407a.333.333 0 0 1 .664.039v.034a.332.332 0 0 1-.027.128l-1.231 2.93a.334.334 0 0 1-.307.204ZM16.915 20.467h-1.93a.333.333 0 0 1 0-.666h1.93a.314.314 0 0 1 .333.333.334.334 0 0 1-.333.333ZM15.377 3.973a.326.326 0 0 0-.243-.09c-.046 0-.103.003-.166.003-.666-.003-2.065-.133-2.614-.752a.299.299 0 0 0-.17-.117.088.088 0 0 0-.04-.01.156.156 0 0 0-.056-.007.165.165 0 0 0-.057.007.089.089 0 0 0-.04.01.302.302 0 0 0-.156.103c-.004.004-.007.01-.014.014-.35.325-.79.537-1.261.609-.446.09-.9.138-1.355.14-.06 0-.117 0-.163-.004a.353.353 0 0 0-.247.094.34.34 0 0 0-.1.24v2.82c0 .006.004.016.004.022a.398.398 0 0 0 .01.14.299.299 0 0 0 .043.093.341.341 0 0 0 .276.147.327.327 0 0 0 .097-.017 9.98 9.98 0 0 1 5.923 0 .332.332 0 0 0 .416-.216c.006-.02.01-.04.01-.06a.252.252 0 0 0 0-.087.048.048 0 0 0 .006-.023v-2.82a.33.33 0 0 0-.103-.24Zm-.563 2.693a10.553 10.553 0 0 0-5.453.003V4.545c.073 0 .16-.003.253-.01.68-.04 1.785-.19 2.474-.746.689.556 1.794.706 2.474.746.093.007.18.01.253.01v2.12Z" /><path fill="#001824" d="M12.246 4.528v.48h.48v.338h-.48v.48h-.338v-.48h-.48v-.338h.48v-.48h.338Zm0-.333h-.338a.333.333 0 0 0-.333.333v.147h-.147a.333.333 0 0 0-.333.333v.338a.333.333 0 0 0 .333.333h.147v.147a.333.333 0 0 0 .333.333h.338a.333.333 0 0 0 .333-.333V5.68h.147a.333.333 0 0 0 .333-.333v-.338a.333.333 0 0 0-.333-.333h-.147v-.147a.333.333 0 0 0-.333-.333ZM14.12 10.306a.666.666 0 1 1-1.333 0 .666.666 0 0 1 1.333 0ZM11.457 10.306a.665.665 0 1 1-1.331 0 .665.665 0 0 1 1.33 0ZM12.122 13.635a2.547 2.547 0 0 1-1.148-.285.332.332 0 0 1-.07-.55.334.334 0 0 1 .368-.046 1.79 1.79 0 0 0 1.7 0 .333.333 0 1 1 .298.596 2.547 2.547 0 0 1-1.148.285Z" /><path fill="#001824" d="M12.122 15.811c-2.266 0-4.108-2.266-4.108-5.051l-.04-.457a.333.333 0 1 1 .663-.057l.041.485c.001 2.447 1.545 4.414 3.444 4.414 1.898 0 3.441-1.967 3.441-4.385 0-.156-.006-.31-.019-.461a.333.333 0 0 1 .664-.054c.014.17.021.34.021.515 0 2.785-1.843 5.051-4.107 5.051Z" /><path fill="#001824" d="M15.8 10.713a.656.656 0 0 1-.407-.145 1.748 1.748 0 0 1-.487-.859.74.74 0 0 1-.11.048c-.486.171-1.08-.21-1.493-.564a.535.535 0 0 1-.055.045c-.35.248-.974.017-1.551-.31a.425.425 0 0 1-.035.032c-.12.104-.392.337-1.645-.435-.336.695-.988 1.902-1.566 2.15A.342.342 0 0 1 8 10.508a3.821 3.821 0 0 1-.132-.357 3.066 3.066 0 0 1 .645-3.091c.079-.083.164-.16.254-.23a.333.333 0 1 1 .41.524 1.706 1.706 0 0 0-.184.167 2.383 2.383 0 0 0-.527 2.299 9.629 9.629 0 0 0 1.108-1.916.333.333 0 0 1 .487-.14 7.06 7.06 0 0 0 1.02.568.334.334 0 0 1 .515-.248c.37.259.776.458 1.207.592a.555.555 0 0 0-.01-.04.332.332 0 0 1 .568-.309c.442.477 1.034.868 1.216.804.038-.014.116-.123.139-.441a.332.332 0 0 1 .326-.31h.005a.333.333 0 0 1 .331.299c.038.438.152.867.34 1.266a1.99 1.99 0 0 0-.01-1.809 1.96 1.96 0 0 0-.482-.623 1.449 1.449 0 0 0-.144-.107.333.333 0 1 1 .357-.562c.074.048.145.1.213.158a2.7 2.7 0 0 1 .505 3.511c-.002.002-.02.03-.022.031a.403.403 0 0 1-.24.164.656.656 0 0 1-.094.006Z" />
                    </svg>
                  </div>
                  <div className={css(styles.drawerMenuItemText)} >
                    Providers
                  </div>
                </Link>
                {/* Access */}
                <div className='fx fx__v-center'>
                  {profileAccess.providers === 6 && readWriteIcon}
                  {profileAccess.providers === 4 && readOnlyIcon}
                  {profileAccess.providers === 0 && noAccessIcon}
                </div>
              </div>
              {/* Collaborators */}
              <div
                className={`noselect
                  ${profileAccess.collaborators === 0 ? 'disabled' : ''}
                  ${pathname.endsWith('/users') ? 'activeitem' : ''}
                  ${css(styles.drawerMenuItem, pathname.endsWith('/users') &&
                  styles.drawerMenuItemActive)}`}
                onClick={() => {
                  if (profileAccess.collaborators !== 0) {
                    history.push(`${url}/users`);
                    if (isMobileLayout) {
                      toggleDrawer(false);
                    }
                  }
                }}
              >
                <Link
                  to={`${url}/users`}
                  className={`${profileAccess.collaborators === 0 ? 'disabled-link' : ''} ${css(styles.linkStyles, pathname.endsWith('/users') && styles.selectedLink)}`}
                  onClick={() => {
                    if (isMobileLayout) {
                      toggleDrawer(false);
                    }
                  }}
                >
                  <div className={css(styles.drawerMenuItemIcon)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
                      <path fill="#96C8FF" fillRule="evenodd" d="M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm14 8c0 2.213-1.787 4-4 4s-4-1.787-4-4 1.787-4 4-4 4 1.787 4 4ZM4 18.667c0-2.667 5.333-4.134 8-4.134s8 1.467 8 4.134V20H4v-1.333Z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className={css(styles.drawerMenuItemText)} >
                    Collborators
                  </div>
                </Link>
                {/* Access */}
                <div className='fx fx__v-center'>
                  {profileAccess.collaborators === 6 && readWriteIcon}
                  {profileAccess.collaborators === 4 && readOnlyIcon}
                  {profileAccess.collaborators === 0 && noAccessIcon}
                </div>
              </div>
              {/* Facility Coverage */}
              <div
                className={`noselect
                  ${profileAccess.facilityCoverage === 0 ? 'disabled' : ''}
                  ${pathname.endsWith('/facilities') ? 'activeitem' : ''}
                  ${css(styles.drawerMenuItem, pathname.endsWith('/facilities') &&
                  styles.drawerMenuItemActive)}`}
                onClick={() => {
                  if (profileAccess.facilityCoverage !== 0) {
                    history.push(`${url}/facilities`);
                    if (isMobileLayout) {
                      toggleDrawer(false);
                    }
                  }
                }}
              >
                <Link
                  to={`${url}/facilities`}
                  className={`${profileAccess.facilityCoverage === 0 ? 'disabled-link' : ''} ${css(styles.linkStyles, pathname.endsWith('/facilities') && styles.selectedLink)}`}
                  onClick={() => {
                    if (isMobileLayout) {
                      toggleDrawer(false);
                    }
                  }}
                >
                  <div className={css(styles.drawerMenuItemIcon)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
                      <path fill="#96C8FF" fillRule="evenodd" d="M0 1a1 1 0 0 1 1-1h13.852a1 1 0 0 1 1 1v22.995H0V1Zm4.533 11.998h6.79v9.998h-6.79v-9.998Zm0-2.753h1.542V7.27h3.708v2.98h1.542V2.822H9.783v2.963H6.075V2.818H4.533v7.427Zm11.826-4.79h6.637a1 1 0 0 1 1 1v17.542H16.36V5.455Zm1.092 2.18h2.182v2.18h-2.182v-2.18Zm5.454 0h-2.182v2.18h2.182v-2.18Zm-2.182 3.276h2.182v2.181h-2.182v-2.181Zm-1.09 0h-2.182v2.181h2.182v-2.181Zm-2.182 3.267h2.182v2.181h-2.182v-2.181Zm5.454 0h-2.182v2.181h2.182v-2.181Z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className={css(styles.drawerMenuItemText)} >
                    Facility Coverage
                  </div>
                </Link>
                {/* Access */}
                <div className='fx fx__v-center'>
                  {profileAccess.facilityCoverage === 6 && readWriteIcon}
                  {profileAccess.facilityCoverage === 4 && readOnlyIcon}
                  {profileAccess.facilityCoverage === 0 && noAccessIcon}
                </div>
              </div>
              {/* Access Manager */}
              <div
                className={`noselect
                  ${profileAccess.accessManager === 0 ? 'disabled' : ''}
                  ${pathname.endsWith('/access-manager') ? 'activeitem' : ''}
                  ${css(styles.drawerMenuItem, pathname.endsWith('/access-manager') &&
                  styles.drawerMenuItemActive)}`}

                onClick={() => {
                  if (profileAccess.accessManager !== 0) {
                    history.push(`${url}/access-manager`);
                    if (isMobileLayout) {
                      toggleDrawer(false);
                    }
                  }
                }}
              >
                <Link
                  to={`${url}/access-manager`}
                  className={`${profileAccess.accessManager === 0 ? 'disabled-link' : ''} ${css(styles.linkStyles, pathname.endsWith('/access-manager') && styles.selectedLink)}`}
                  onClick={() => {
                    if (isMobileLayout) {
                      toggleDrawer(false);
                    }
                  }}
                >
                  <div className={css(styles.drawerMenuItemIcon)}>
                    {/* <i className='fa fa-building' /> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="24" fill="none">
                      <path fill="#96C8FF" fillRule="evenodd" d="M15.997 8h-1.143V5.714A5.716 5.716 0 0 0 9.141 0a5.716 5.716 0 0 0-5.713 5.714V8H2.285A2.292 2.292 0 0 0 0 10.286v11.428A2.292 2.292 0 0 0 2.285 24h13.712a2.292 2.292 0 0 0 2.285-2.286V10.286A2.292 2.292 0 0 0 15.997 8ZM9.142 18.286A2.292 2.292 0 0 1 6.857 16a2.292 2.292 0 0 1 2.285-2.286A2.292 2.292 0 0 1 11.428 16a2.292 2.292 0 0 1-2.286 2.286ZM5.712 5.764v2.24h6.856v-2.24c0-1.916-1.537-3.474-3.428-3.474-1.89 0-3.428 1.558-3.428 3.474Z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className={css(styles.drawerMenuItemText)} >
                    Access Manager
                  </div>
                </Link>
                {/* Access */}
                <div className='fx fx__v-center'>
                  {profileAccess.accessManager === 6 && readWriteIcon}
                  {profileAccess.accessManager === 4 && readOnlyIcon}
                  {profileAccess.accessManager === 0 && noAccessIcon}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Panel details */}
        <div className={css(styles.detail, !isDrawerOpen && styles.detailExapnd)}>
          <div className={css(styles.detailHeader)}>
            <div>{activeText}</div>
          </div>
          {/* Active component */}
          {/* {comp} */}
          <Switch>
            <Route exact path={`${path}`}>
              <AboutPractice
                practiceData={activePractice}
                reloadPracticeData={handleReloadPracticeData}
                showEllipsisBtn={profileAccess.profile === 6}
              />
            </Route>
            <Route path={`${path}/profile`}>
              <AboutPractice
                practiceData={activePractice}
                reloadPracticeData={handleReloadPracticeData}
                showEllipsisBtn={profileAccess.profile === 6}
              />
            </Route>
            <Route path={`${path}/providers`}>
              <PracticeProvidersGrid
                profileAccess={profileAccess}
                owners={activePractice.users}
                practice={activePractice}
                practiceNpi={practiceNpi}
              />
            </Route>
            <Route path={`${path}/users`}>
              <PracticeUsersGrid
                profileAccess={profileAccess}
                owners={activePractice.users}
                practice={activePractice}
                practiceNpi={practiceNpi}
              />
            </Route>
            <Route path={`${path}/facilities`}>
              <PracticeFacilitiesGrid
                practiceId={activePractice._id}
              />
            </Route>
            <Route path={`${path}/insurance`}>
              <Placeholder text='Placeholder for Insurance' />
            </Route>
            <Route path={`${path}/payments`}>
              <Placeholder text='Placeholder for Payments Ledger' />
            </Route>
            <Route path={`${path}/credentialing`}>
              <Placeholder text='Placeholder for Credentialing' />
            </Route>
            <Route path={`${path}/access-manager`}>
              {profileAccess.accessManager > 0
                ? <PracticeAccessManagersGrid
                  practiceNpi={practiceNpi}
                  premissionMode={profileAccess.accessManager}
                />
                : NoView
              }
            </Route>
            <Route path={`${path}/revenue`}>
              <Placeholder text='Placeholder for Revenue Cycle' />
            </Route>

          </Switch>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps({ user }) {
  return { ...user };
}

export default connect(mapStateToProps, {
  togglePracticeDataReloadFlag
})(PracticeDashboard);
